import moment from 'moment'

export const convertDate = (dateString: string, dataFixedTimezone: string | undefined): Date =>
    moment(dataFixedTimezone ? dateString : dateString + 'Z').toDate()
